/* BRANDSETS – prezent do zamówienia (snippets/bs-gift.liquid)
   Pilnuje, żeby produkt-prezent był w koszyku dokładnie wtedy, gdy suma produktów >= próg:
   - po każdej zmianie koszyka (dodanie, zmiana ilości, usunięcie – wszystko, co idzie przez fetch /cart/...),
   - przy wejściu na stronę.
   Po dodaniu produktu pokazuje dymek „Brakuje Ci jeszcze X zł, aby otrzymać gratis!” / „Prezent jest Twój”. */
(function () {
  var C = window.bsGift;
  if (!C || !C.variantId || window.__bsGiftInit) return;
  window.__bsGiftInit = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var timer = null;
  var pendingAdd = false;
  var running = false;
  var rerun = false;

  function isCartWrite(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$|\/)/.test(url);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (isCartWrite(url)) {
      var isAdd = /\/cart\/add/.test(url);
      p.then(function (r) { if (r && r.ok) schedule(isAdd); }).catch(function () {});
    }
    return p;
  };

  function schedule(isAdd) {
    if (isAdd) pendingAdd = true;
    clearTimeout(timer);
    timer = setTimeout(run, 400);
  }

  function money(cents) {
    var v = cents / 100;
    var s = v.toLocaleString('pl-PL', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return s + ' zł';
  }

  function post(path, body) {
    return nativeFetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function run() {
    if (running) { rerun = true; return; }
    running = true;
    var showToast = pendingAdd;
    pendingAdd = false;

    nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gift = null;
        var paid = 0;
        (cart.items || []).forEach(function (it) {
          if (it.variant_id === C.variantId || it.product_id === C.productId) gift = it;
          else if (C.exclude.indexOf(it.variant_id) === -1) paid += it.final_line_price;
        });
        var ok = C.enabled !== false && paid >= C.threshold;
        var job = null;
        var added = false;

        if (ok && !gift && C.available) { job = post('cart/add.js', { items: [{ id: C.variantId, quantity: 1 }] }); added = true; }
        else if (!ok && gift) job = post('cart/change.js', { id: gift.key, quantity: 0 });
        else if (ok && gift && gift.quantity !== 1) job = post('cart/change.js', { id: gift.key, quantity: 1 });

        if (showToast && paid > 0 && C.enabled !== false) {
          if (!ok) toast('Brakuje Ci jeszcze ' + money(C.threshold - paid) + ', aby otrzymać gratis!', paid / C.threshold);
          else if (added) toast('Prezent jest Twój', 1);
        }
        return job ? job.then(refresh) : null;
      })
      .catch(function () {})
      .then(function () {
        running = false;
        if (rerun) { rerun = false; run(); }
      });
  }

  /* odświeżenie koszyka bocznego i licznika po dodaniu/usunięciu prezentu */
  function refresh() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    return nativeFetch(root + '?sections=cart-drawer,cart-counter', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var P = new DOMParser();
        var body = document.querySelector('#CartDrawer-Body');
        if (body && s['cart-drawer']) {
          var nb = P.parseFromString(s['cart-drawer'], 'text/html').querySelector('#CartDrawer-Body');
          if (nb) body.innerHTML = nb.innerHTML;
        }
        var cnt = document.querySelector('#cart-counter');
        if (cnt && s['cart-counter']) {
          var nc = P.parseFromString(s['cart-counter'], 'text/html').querySelector('#shopify-section-cart-counter');
          if (nc) cnt.innerHTML = nc.innerHTML;
        }
        if (typeof window.updateCartCounters === 'function') try { updateCartCounters(); } catch (e) {}
        if (typeof window.updateFreeShipping === 'function') try { updateFreeShipping(); } catch (e) {}
        pop();
      })
      .catch(function () {});
  }

  /* dymek */
  var tEl = null, tHide = null;
  function toast(title, progress) {
    /* telefon + otwarty koszyk: zamiast dymka mignie karta / pozycja prezentu w koszyku */
    var drawer = document.querySelector('cart-drawer');
    setTimeout(function () {
      if (window.innerWidth < 750 && drawer && drawer.classList.contains('is-visible')) { pop(); return; }
      if (!tEl) {
        tEl = document.createElement('div');
        tEl.className = 'bs-gift-toast';
        tEl.setAttribute('role', 'status');
        tEl.setAttribute('aria-live', 'polite');
        tEl.addEventListener('click', hide);
        document.body.appendChild(tEl);
      }
      var done = progress >= 1;
      tEl.innerHTML = C.icon +
        '<span class="bs-gift-toast__txt"><strong></strong><span class="bs-gift-toast__sub"><span class="bs-gift-toast__n"></span>' +
        (C.value ? '<span class="bs-gift__val"><del>' + money(C.value) + '</del> 0 zł</span>' : '<span class="bs-gift__val">gratis</span>') +
        '</span>' + (done ? '' : '<span class="bs-gift__bar" aria-hidden="true"><i style="width:' + Math.max(4, Math.round(progress * 100)) + '%"></i></span>') +
        '</span><button type="button" class="bs-gift-toast__x" aria-label="Zamknij">×</button>';
      tEl.querySelector('strong').textContent = title;
      tEl.querySelector('.bs-gift-toast__n').textContent = C.name;
      /* setTimeout zamiast requestAnimationFrame – w karcie w tle rAF czeka, a dymek zostawałby na stałe */
      clearTimeout(tHide);
      setTimeout(function () { tEl.classList.add('is-in'); }, 20);
      tHide = setTimeout(hide, 5200);
    }, 650);
  }
  function pop() {
    var el = document.querySelector('cart-drawer [data-bs-gift-card]') || document.querySelector('cart-drawer .cart-item--gift');
    if (el) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }
  }
  function hide() { if (tEl) tEl.classList.remove('is-in'); }

  /* przy wejściu na stronę (np. koszyk zmieniony bez JS albo w innej karcie) */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(false); });
  else schedule(false);
})();
